import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Upload, Download, ChevronDown, FileUp } from "lucide-react";

// Bottone "Import massivo" che ingloba anche il download del template.
export default function ImportButton({ onPickFile, onTemplate, importing, testid = "import" }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" data-testid={`${testid}-menu-button`} disabled={importing}>
          <Upload className="h-4 w-4 mr-1.5" /> {importing ? "Import…" : "Import massivo"}
          <ChevronDown className="h-3.5 w-3.5 ml-1.5 opacity-60" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-52">
        <DropdownMenuItem data-testid={`${testid}-upload-item`} onClick={onPickFile}>
          <FileUp className="h-4 w-4 mr-2" /> Carica file…
        </DropdownMenuItem>
        <DropdownMenuItem data-testid={`${testid}-template-item`} onClick={onTemplate}>
          <Download className="h-4 w-4 mr-2" /> Scarica template
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
